const resumeParsed = (data) => ({
  type: 'RESUME_PARSED',
  data,
});

const reinitializeResume = () => ({
  type: 'REINITIALIZE_RESUME',
});

const linkedinProfileParsed = (data) => ({
  type: 'LINKEDIN_PROFILE_PARSED',
  data,
});

const profileSuggestionsParsed = (data) => ({
  type: 'PROFILE_SUGGESTIONS_PARSED',
  data,
});

const updateBio = (data) => ({
  type: 'UPDATE_BIO',
  data,
});

const updateLocation = (data) => ({
  type: 'UPDATE_LOCATION',
  data,
});

const updateArray = (id, newArray) => ({
  type: 'UPDATE_ARRAY',
  data: { id, newArray },
});

export default {
  resumeParsed,
  reinitializeResume,
  linkedinProfileParsed,
  profileSuggestionsParsed,
  updateBio,
  updateLocation,
  updateArray,
};
